import { useState, useEffect } from "react";

const useLazyLoading = (loading: boolean, delay = 250) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer: any;

    if (loading) {
      timer = setTimeout(() => setShow(true), delay);
    } else {
      setShow(false);
    }

    return () => clearTimeout(timer);
  }, [loading, delay]);

  return show;
};

export default useLazyLoading;
